export default __webpack_public_path__ + "static/media/layer_checklist_2.33dc5bfa.svg";